import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import PageWrapper from 'shared/lib/components/containers/pageWrapper';
import PagePaddingWrapper from 'shared/lib/components/containers/pagePaddingWrapper';
import BlockHeader from 'pages/components/blockHeader';
import PageInnerContainer from 'pages/components/pageInnerContainer';
import CustomTabs from 'shared/lib/components/controls/tabs/customTabs';
import CustomTab from 'shared/lib/components/controls/tabs/customTab';
import UploadFiles from 'pages/uploadPage/uploadFiles/uploadFiles';
import { Box } from '@mui/material';
import UploadTable from 'pages/uploadPage/uploadTable/uploadTable';
import BreadcrumbsItem from 'shared/lib/components/controls/breadcrumbs/breadcrumbsItem';
import { useNavigate } from 'react-router-dom';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import { useExplorerStore } from 'app/hooks/useExplorerStore';
import Breadcrumbs from 'shared/lib/components/controls/breadcrumbs/breadcrumbs';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import { useTranslation } from 'react-i18next';
import { useEntityPath } from 'app/hooks/useEntityPath';
import map from 'lodash-es/map';
import UploadFolder from 'pages/uploadPage/uploadFolder/uploadFolder';
import { FolderModel } from 'entities/folder/model/folderModel';
import { ExplorerEntityTypes } from 'entities/types';

enum TabValue {
  FILE = 'file',
  TABLE = 'table',
  FOLDER = 'folder',
}

export default observer(function UploadPage() {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(TabValue.FILE);
  const navigate = useNavigate();
  const { mobxStore } = useContext(MobxContext);

  const { getSectionSearchParams, getFolderSearchParams } =
    useSearchParamsUtils();

  const currentEntity = useExplorerStore(mobxStore.explorerStore);

  const sectionId =
    currentEntity?.type === ExplorerEntityTypes.SECTION
      ? currentEntity.model.id
      : currentEntity?.type === ExplorerEntityTypes.FOLDER
      ? (currentEntity.model as FolderModel).sectionId
      : null;

  const folderId =
    currentEntity?.type === ExplorerEntityTypes.FOLDER
      ? currentEntity.model.id
      : '';

  const name =
    currentEntity?.type === ExplorerEntityTypes.FOLDER
      ? currentEntity?.model.data?.name
      : '';

  const path = useEntityPath(
    currentEntity
      ? {
          id: currentEntity.model.id,
          type: currentEntity.type,
          name: currentEntity?.model.data?.name || '',
        }
      : null
  );

  return (
    <PageWrapper>
      <PagePaddingWrapper>
        <Box>
          <Breadcrumbs>
            <BreadcrumbsItem
              onClick={() => {
                navigate('/', { replace: false });
              }}
              title={t('breadcrumbs.main')}
            >
              {t('breadcrumbs.main')}
            </BreadcrumbsItem>

            {path.sectionMeta ? (
              <BreadcrumbsItem
                key={path.sectionMeta.id}
                onClick={() => {
                  navigate({
                    pathname: '/explorer',
                    search: getSectionSearchParams({
                      sectionId: path.sectionMeta!.id,
                    }),
                  });
                }}
                title={path.sectionMeta.name}
              >
                {path.sectionMeta.name}
              </BreadcrumbsItem>
            ) : null}

            {path.foldersMeta
              ? map(path.foldersMeta, (item) => (
                  <BreadcrumbsItem
                    key={item.id}
                    onClick={() => {
                      navigate({
                        pathname: '/explorer',
                        search: getFolderSearchParams({
                          folderId: item.id,
                        }),
                      });
                    }}
                    title={item.name}
                  >
                    {item.name}
                  </BreadcrumbsItem>
                ))
              : null}
            <BreadcrumbsItem title={t('common.uploading')}>
              {t('common.uploading')}
            </BreadcrumbsItem>
          </Breadcrumbs>
        </Box>

        <PageInnerContainer>
          <BlockHeader text={t('common.uploading')}></BlockHeader>

          <CustomTabs
            value={tabValue}
            onChange={(e, value) => setTabValue(value)}
          >
            <CustomTab
              value={TabValue.FILE}
              label="загрузка файлов"
            ></CustomTab>
            <CustomTab
              value={TabValue.TABLE}
              label="добавление таблицы"
            ></CustomTab>
            <CustomTab
              value={TabValue.FOLDER}
              label="загрузка папки"
            ></CustomTab>
          </CustomTabs>

          <Box>
            <UploadFiles
              isVisible={tabValue === TabValue.FILE}
              initialSectionId={sectionId || null}
              initialFolderId={folderId}
              initialName={name}
            ></UploadFiles>
            <UploadTable
              isVisible={tabValue === TabValue.TABLE}
              initialSectionId={sectionId || null}
              initialFolderId={folderId}
              initialName={name}
            ></UploadTable>
            <UploadFolder
              isVisible={tabValue === TabValue.FOLDER}
              initialSectionId={sectionId || null}
              initialFolderId={folderId}
              initialName={name}
            ></UploadFolder>
          </Box>
        </PageInnerContainer>
      </PagePaddingWrapper>
    </PageWrapper>
  );
});
